import type { ITheme } from 'bz-core-controls/styles/theme/store/theme';
import { generateThemeColors } from 'reshaped/themes';
import colors from 'tailwindcss/colors';

const RpGrayBlueTheme: ITheme = Object.freeze({
  id: 16,
  accent: 'gray',
  name: 'gray blue',
  primary: 'blue',
  secondary: '',
  reshapedTheme: {
    color: {
      ...generateThemeColors({ primary: colors.blue[600] }),
      sidebarBackground: { hex: colors.gray[700], darkHex: colors.gray[700] },
      sidebarBackgroundActive: { hex: colors.gray[800], darkHex: colors.gray[800] },
      sidebarBackgroundHover: { hex: colors.gray[600], darkHex: colors.gray[600] },
      sidebarIcon: { hex: colors.gray[300], darkHex: colors.gray[300] },
      sidebarText: { hex: colors.gray[100], darkHex: colors.gray[100] },
      backgroundPage: { hex: '#f8fafc', darkHex: '#f8fafc' }
    }
  }
});

export default RpGrayBlueTheme;
